import { render, staticRenderFns } from "./StaAll.vue?vue&type=template&id=38e8733c&scoped=true&"
import script from "./StaAll.vue?vue&type=script&lang=js&"
export * from "./StaAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8733c",
  null
  
)

export default component.exports